import {
  CredentialsGetExtensibleFields,
  ICredential,
} from '@commenda/types/src/credential/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

type GetCredentialsQueryParams = {
  businessEntityId: number;
  extends?: CredentialsGetExtensibleFields[];
};

export function useCredentials(params: GetCredentialsQueryParams) {
  const queryString = new URLSearchParams();

  if (params.businessEntityId) {
    queryString.append('businessEntityId', params.businessEntityId.toString());
  }
  if (params.extends) queryString.append('extends', params.extends.join(','));

  const {
    data,
    error,
    mutate,
  }: {
    data?: { credentials: ICredential[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    params.businessEntityId ? `credentials?${queryString.toString()}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
